import HighlightedContent from './container'
export default HighlightedContent
